import { motion } from "framer-motion";

const ITEMS = [
    { tag: "Malaysia", title: "Strategic Malaysian Location" },
    { tag: "Global", title: "International Business Perspective" },
    { tag: "Markets", title: "Multi-Market Access" },
    { tag: "Scale", title: "Asset-Light Scalability" },
    { tag: "Network", title: "Strong Supply Chain Partnerships" },
    { tag: "Focus", title: "Customer-Focused Solutions" },
    { tag: "Trust", title: "Commitment to Compliance" },
    { tag: "Vision", title: "Long-Term Vision" },
];

export const Advantages = () => {
    return (
        <section
            id="advantages"
            data-testid="advantages-section"
            className="relative bg-[#0B0807]/82 backdrop-blur-md py-24 sm:py-32 lg:py-40 px-4 sm:px-8 lg:px-12 border-t border-white/5"
        >
            <div className="flex items-center gap-3 font-mono-text text-[10px] sm:text-xs uppercase tracking-[0.3em] text-zinc-500 mb-6">
                <span className="h-px w-10 bg-[#D69331]" />
                <span>07 / Competitive Advantages</span>
            </div>

            <motion.h2
                initial={{ y: 60, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="font-display uppercase font-bold leading-[0.9] tracking-tight text-white text-4xl sm:text-6xl lg:text-7xl max-w-5xl"
            >
                What makes DUHA{" "}
                <span className="text-[#D69331]">different.</span>
            </motion.h2>

            <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-900 border border-zinc-900">
                {ITEMS.map((it, i) => (
                    <motion.div
                        key={it.title}
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: "-30px" }}
                        transition={{ duration: 0.4, delay: i * 0.05 }}
                        whileHover={{ y: -2 }}
                        className="bg-[#0a0a0a] hover:bg-[#D69331] hover:text-black transition-colors duration-300 p-6 sm:p-8 lg:p-10 min-h-[200px] sm:min-h-[240px] flex flex-col justify-between group"
                    >
                        <span className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-zinc-500 group-hover:text-black/70 transition-colors">
                            {it.tag}
                        </span>
                        <h3 className="font-display uppercase text-lg sm:text-xl lg:text-2xl font-semibold leading-tight text-white group-hover:text-black transition-colors">
                            {it.title}
                        </h3>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};
